import { render, staticRenderFns } from "./NorticButton.vue?vue&type=template&id=482940e0&scoped=true&"
import script from "./NorticButton.vue?vue&type=script&lang=js&"
export * from "./NorticButton.vue?vue&type=script&lang=js&"
import style0 from "./NorticButton.vue?vue&type=style&index=0&id=482940e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482940e0",
  null
  
)

export default component.exports